// Constants for different requests for current reducer
export default {
  login: 'LOGIN',
  logout: 'LOGOUT',
  resetLogin: 'RESET_LOGIN',
  expiredModal: 'EXPIRED_MODAL',
  sessionInfo: 'SESSION_INFO',
  acceptAgreement: 'acceptAgreement',
};
